import {Component} from '@angular/core';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {ActivatedRoute} from '@angular/router';
import {CookieService} from 'ngx-cookie';
import {KeycloakService} from 'keycloak-angular';

@Component({
    templateUrl: './api.component.html',
    styleUrls: ['./api.component.scss'],
    standalone: false
})
export class ApiComponent {
    iframeSrc: SafeResourceUrl;
    private endpoint: string;
    private token: string;
    private doc: string;

    constructor(private route: ActivatedRoute, private sanitizer: DomSanitizer, private cookieService: CookieService,
                protected readonly keycloak: KeycloakService,
            ) {
    }


    ngAfterViewInit() {
        this.keycloak.getToken().then(token => {
            const bearerToken = 'Bearer ' + token;
            this.route.queryParams.subscribe(params => {
                this.updateUrl({...params, token: bearerToken});
            });
        }).catch(error => {
            console.error('Failed to get Keycloak token:', error);
        });
    }

    private updateUrl(params: any) {
        if (params.doc) {
            this.doc = params.doc;
        }
        if (params.endpoint) {
            this.endpoint = params.endpoint;
        }
        if (params.token) {
            this.token = params.token;
        } else {
            return;
        }
        //
        let urlIframe = `swagger-ui/index.html?csrf=${this.getCSRF()}`;
        if (this.doc) {
            urlIframe += `&doc=${this.doc}`;
        }
        if (this.token) {
            urlIframe += `&token=${this.token}`;
        }
        if (this.endpoint) {
            urlIframe += `#!/${this.endpoint}`;
        }
        this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(urlIframe);
    }

    getCSRF(name = 'access_token') {
        return this.cookieService.get(name);
    }
}
